module.exports = __webpack_public_path__ + "media/promo/courses/images/bg-c12f2f485344e75a98e3d540936f7ef1.jpg";